"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveOutUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var screen_reader_route_manager_1 = __importDefault(require("screen-reader-route-manager"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../../../shared/core/analytics-subjects");
var components_1 = require("../../../../../shared/core/components");
var analytics_subjects_2 = require("../../../../payments/analytics-subjects");
var analytics_subjects_3 = require("../../../analytics-subjects");
var components_2 = require("../../../components");
var copy_1 = require("../../../copy");
var use_create_move_out_1 = require("../../../data/use-create-move-out");
var utils_1 = require("../../../utils");
var dateId = 'move-out-date';
var addressId = 'move-out-address';
var now = (0, date_fns_1.startOfToday)();
var minDate = (0, date_fns_1.addDays)(now, -28);
var maxDate = (0, date_fns_1.addDays)(now, 28);
function getErrorMessage(errors, id) {
    var error = errors.find(function (_a) {
        var errorId = _a.id;
        return errorId === id;
    });
    if (!error) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        error.message,
        " ",
        error.inputOnlyAdditionalMessage));
}
function MoveOutUI(_a) {
    var _b, _c, _d, _e;
    var accountId = _a.accountId, moveOut = _a.moveOut;
    var region = core_1.configService.getConfig().retailer.region;
    var _f = __read((0, react_1.useState)([]), 2), errors = _f[0], setErrors = _f[1];
    var _g = __read((0, react_1.useState)({
        day: '',
        month: '',
        year: '',
    }), 2), date = _g[0], setDate = _g[1];
    var _h = __read((0, react_1.useState)({
        line1: '',
        line2: '',
        town: '',
        postcode: '',
    }), 2), forwardingAddress = _h[0], setForwardingAddress = _h[1];
    var _j = __read((0, react_1.useState)(false), 2), forwardingAddressChecked = _j[0], setForwardingAddressChecked = _j[1];
    var _k = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _k.copy, Copy = _k.Copy;
    var navigate = (0, ui_tools_1.useNavigate)();
    var _l = (0, core_1.useComponents)(), PrimaryCTAButton = _l.PrimaryCTAButton, Card = _l.Card, Stack = _l.Stack, ErrorSummaryNotification = _l.ErrorSummaryNotification, Heading1 = _l.Heading1, Heading2 = _l.Heading2, ButtonGroup = _l.ButtonGroup, Checkbox = _l.Checkbox, AddressField = _l.AddressField, WarningNotification = _l.WarningNotification;
    var supplyPointAddress = moveOut.formattedAddress;
    var _m = __read((0, react_1.useState)(false), 2), moveOutError = _m[0], setMoveOutError = _m[1];
    var _o = (0, core_1.useLinks)(), home = _o.home, moveOutConfirm = _o.moveOutConfirm;
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var _p = (0, use_create_move_out_1.useCreateMoveOut)({ accountId: accountId }), mutate = _p.mutate, loading = _p.loading;
    var moveOutAccount = (0, utils_1.getMoveOutAccount)(accountId);
    var moveOutDate = (moveOutAccount === null || moveOutAccount === void 0 ? void 0 : moveOutAccount.cancelled) === true
        ? null
        : (moveOutAccount === null || moveOutAccount === void 0 ? void 0 : moveOutAccount.moveOutDate) || moveOut.moveOutDate;
    var confirmMoveOut = function (event) {
        var _a;
        event.preventDefault();
        if (loading) {
            return;
        }
        // Reset the errors.
        setErrors([]);
        var localErrors = [];
        // Do the date validation.
        if (!(0, utils_1.isValidDate)((0, utils_1.dateToString)(date))) {
            localErrors.push({
                id: dateId,
                message: copy('dateError'),
            });
        }
        else {
            var chosenDate = (0, date_fns_1.parseISO)((0, utils_1.dateToString)(date));
            if ((0, date_fns_1.isBefore)(chosenDate, minDate)) {
                localErrors.push({
                    id: dateId,
                    message: copy('minDateError', {
                        minDate: (0, date_fns_1.format)(minDate, 'do MMMM'),
                    }),
                    inputOnlyAdditionalMessage: react_1.default.createElement(Copy, { copyKey: "minDateInputOnlyError" }),
                });
            }
            else if ((0, date_fns_1.isAfter)(chosenDate, maxDate)) {
                localErrors.push({
                    id: dateId,
                    message: copy('maxDateError', {
                        maxDate: (0, date_fns_1.format)(maxDate, 'do MMMM'),
                    }),
                });
            }
        }
        // Do the address validation.
        if (!forwardingAddressChecked) {
            if (!(0, utils_1.isValidAddressLine)('line1', forwardingAddress.line1)) {
                localErrors.push({
                    id: "".concat(addressId, "-line1"),
                    message: copy('line1Error'),
                });
            }
            if (!(0, utils_1.isValidAddressLine)('town', forwardingAddress.town)) {
                localErrors.push({
                    id: "".concat(addressId, "-town"),
                    message: copy('townError'),
                });
            }
            if (!(0, utils_1.isValidAddressLine)('postcode', forwardingAddress.postcode)) {
                localErrors.push({
                    id: "".concat(addressId, "-postcode"),
                    message: copy('postcodeError'),
                });
            }
        }
        // Return early if there are validation errors.
        if (localErrors.length) {
            setErrors(localErrors);
            dispatch({
                name: analytics_subjects_1.MOVEOUT_VALIDATION_ERROR,
                type: 'render',
                properties: (_a = {
                        errors: localErrors.map(function (_a) {
                            var id = _a.id;
                            return id;
                        })
                    },
                    _a[core_1.INTERNAL_EVENT_FLAG] = true,
                    _a),
            });
            return;
        }
        var address = !forwardingAddressChecked ? forwardingAddress : undefined;
        mutate({
            moveOutDate: (0, utils_1.dateToString)(date),
            forwardingAddress: address
                ? {
                    line1: address.line1,
                    line2: address === null || address === void 0 ? void 0 : address.line2,
                    postalCode: address.postcode,
                    town: address.town,
                }
                : undefined,
        }, {
            onError: function () { return setMoveOutError(true); },
            onCompleted: function () {
                screen_reader_route_manager_1.default.beforeRouteChange();
                var moveOutAccount = {
                    accountId: accountId,
                    moveOutDate: (0, utils_1.dateToString)(date),
                    cancelled: false,
                };
                (0, utils_1.updateMoveOutAccounts)(moveOutAccount);
                navigate({
                    pathname: moveOutConfirm(),
                    search: "?date=".concat((0, utils_1.dateToString)(date)),
                });
            },
        });
    };
    if (moveOutError) {
        return react_1.default.createElement(components_2.PostError, null);
    }
    if (moveOutDate) {
        navigate({
            pathname: moveOutConfirm(),
            search: "?date=".concat(moveOutDate),
        }, { replace: true });
        return null;
    }
    var forwardingAddressEntered = !forwardingAddressChecked;
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_3.MOVE_OUT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement("div", null,
            react_1.default.createElement(ErrorSummaryNotification, { id: "error-summary", errors: errors })),
        react_1.default.createElement("section", null,
            react_1.default.createElement(Card, { "data-testid": "moveOut" },
                react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
                    react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_3.MOVE_OUT_BACK_BREADCRUMB, properties: (_c = { date: date }, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c) },
                        react_1.default.createElement(components_1.Breadcrumb, { "data-testid": "breadcrumb", href: home() },
                            react_1.default.createElement(Copy, { copyKey: "backtoHome" }))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Heading1, null,
                            react_1.default.createElement(Copy, { copyKey: "moveOutHeading" }))),
                    region !== 'UK' ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(WarningNotification, { id: "notification-move-out-not-supported" },
                            react_1.default.createElement(Copy, { copyKey: "moveOutNotSupported" })))) : !moveOut.canSelfServe ? (react_1.default.createElement(Copy, { copyKey: "moveOutNoSelfServeIntro", values: { address: supplyPointAddress } })) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Copy, { copyKey: "moveOutIntro", values: { address: supplyPointAddress } }),
                        react_1.default.createElement("form", { onSubmit: confirmMoveOut, method: "PUT", noValidate: true },
                            react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement(Heading2, null, copy('formHeading')),
                                    react_1.default.createElement(components_1.DatepickerField, { id: dateId, label: copy('formDateLabel'), hint: copy('formDatepickerHint'), error: getErrorMessage(errors, dateId), onChange: function (date) {
                                            var _a = __read(date.trim().split('/'), 3), day = _a[0], month = _a[1], year = _a[2];
                                            setDate({
                                                day: day,
                                                month: month,
                                                year: year,
                                            });
                                        }, isDateUnavailable: function (date) {
                                            return (0, date_fns_1.isBefore)(date.toString(), minDate) ||
                                                (0, date_fns_1.isAfter)(date.toString(), maxDate);
                                        } })),
                                react_1.default.createElement(Heading2, null, copy('forwardingAddressQuestion')),
                                react_1.default.createElement(Copy, { copyKey: "forwardingAddressInfo" }),
                                react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_2.NO_FORWARDING_ADDRESS, properties: (_d = {}, _d[core_1.INTERNAL_EVENT_FLAG] = true, _d) },
                                    react_1.default.createElement(Checkbox, { label: copy('forwardingAddressCheckbox'), id: "forwarding-address-checkbox", "data-testid": "fwd-add-check", checked: forwardingAddressChecked, onChange: function () {
                                            return setForwardingAddressChecked(!forwardingAddressChecked);
                                        } })),
                                !forwardingAddressChecked ? (react_1.default.createElement(AddressField, { id: addressId, "data-testid": "address-field", onChange: setForwardingAddress, value: forwardingAddress, errors: errors })) : null,
                                react_1.default.createElement(ButtonGroup, null,
                                    react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_3.MOVE_OUT_CONFIRM, properties: (_e = {
                                                date: date,
                                                forwardingAddressEntered: forwardingAddressEntered
                                            },
                                            _e[core_1.INTERNAL_EVENT_FLAG] = true,
                                            _e) },
                                        react_1.default.createElement(PrimaryCTAButton, { type: "submit", "data-testid": "move-out-confirm-button", disabled: loading }, copy('formConfirmButtonText')))))))))))));
}
exports.MoveOutUI = MoveOutUI;
